export default __webpack_public_path__ + "static/media/searchIcon.5d56e629.svg";